import './Library.scss';

import React, { useContext } from 'react';
import { SegmentContext } from '../../index'
import Slotter from '../Slotter'

function Library() {
  const { segment, solution } = useContext(SegmentContext)
  const { categories, sections } = segment || {}

  return (
    <div>
      <div className="library">

        <Slotter minWidth={992}>
          <div className="section-empty" >
            &nbsp;
          </div>
          <Slotter className="section-names" slotSize={sections.reduce((acc, cur) => (acc + cur.size), 0)} >
            { sections.filter(section => section.size).map((section, sIndex) => {            
              return (
                <div key={sIndex} slotSize={section.size || 1} className="section-name">{section.name}</div>
              )
            }) }     
          </Slotter>
        </Slotter>
              
        { categories.map((category, cIndex) => {

          const { hasFullSlots = true, hasSmallSlots = true } = category

          return (  
            <Slotter key={cIndex} className="category" minWidth={992} >
              <div className="category-head">              
                { category.name }              
              </div>
              <div slotSize={sections.reduce((acc, cur) => (acc + cur.size), 0)}>

                { hasSmallSlots && (
                  <Slotter>
                    { sections.filter(section => section.size).map((section, sIndex) => {
                      const applications = segment.applications.filter(item => ( item.category === category.id && item.section === section.id ) )
                      return (
                        <Slotter key={sIndex} slotterSize={section.size || 1} slotSize={section.size || 1}  >
                          { applications.length ? 
                              applications.map((application, aIndex) => {
                                return (
                                  <div key={aIndex} className={'application' + ((solution &&  application.solutions.indexOf(solution.id) !== -1) ? ' active' : '') + (application.style ? ` ${application.style}` : '') }>
                                    { application.name }
                                  </div>
                                )
                              }) : 
                              ( <div>&nbsp;</div> )
                          }
                        </Slotter>
                      )
                    }) }
                  </Slotter>
                ) }

                { hasFullSlots && (
                  <div>
                    { sections.filter(section => !section.size).map((section, sIndex) => { 
                      const applications = segment.applications.filter(item => ( item.category === category.id && item.section === section.id ) )
                      if (!applications.length) {
                        return null
                      }
                      return (
                        <>
                          { 
                            applications.map((application, aIndex) => {
                              return (
                                <div key={aIndex} className={'application' + ((solution &&  application.solutions.indexOf(solution.id) !== -1) ? ' active' : '') + (application.style ? ` ${application.style}` : '') }>
                                  { application.name }
                                </div>
                              )
                            })
                          }         
                        </>
                      )
                    }) }
                  </div>
                ) }


              </div>
            </Slotter>
          )
        }) }
        </div>
    </div>
  );
}

export default Library;